/* LA DIVINE — E1 : réconciliation ÉVÉNEMENTIELLE de la ligne « supplément » (page ET drawer).
   Après chaque mutation du panier (Horizon émet cart:update), on recalcule la quantité de
   supplément attendue = Σ (_éph × quantité) sur les lignes coffret ; on corrige via
   /cart/change.js (0 = suppression de l'orphelin), puis on redispatche cart:update (marqué)
   pour que Horizon re-rende le panier/drawer SANS rechargement.
   Fail-safe STRICT : données absentes/ambiguës => ne rien faire.
   Anti-boucle : verrou `busy` pendant l'application + on ignore notre propre cart:update ;
   convergence naturelle (une fois corrigé, plus aucune différence => plus aucune correction). */
(function () {
  'use strict';
  /* Prefixe de locale (27/08) : un appel Ajax panier a la racine part en redirection vers
     /fr-fr/... a chaque synchro. Shopify.routes.root vaut '/fr-fr/' sur une page FR. */
  function ldRacine() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  if (window.__ldCartSyncLoaded) return;
  window.__ldCartSyncLoaded = true;

  var busy = false;
  var timer = null;

  function computeChanges(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    var items = cart.items;
    var present = {}, expected = {}, hasEph = {}, expectedG = {}, hasG = {};
    items.forEach(function (it) {
      var vid = String(it.variant_id || it.id);
      present[vid] = true;
      var p = it.properties || {};
      if (p['_lié'] != null || p['_liéG'] != null) return;   // lignes supplément : traitées plus bas
      if (p['_éph'] != null) {                        // ligne coffret/PM configurée
        var e = parseInt(p['_éph'], 10);
        if (!isNaN(e)) { expected[vid] = (expected[vid] || 0) + e * it.quantity; hasEph[vid] = true; }
      }
      // B10-3 — supplément SOMMITALE éphémère : 1 par boîte quand la ligne porte _grandeEph.
      if (p['_grandeEph'] != null) {
        var g = parseInt(p['_grandeEph'], 10);
        if (!isNaN(g)) { expectedG[vid] = (expectedG[vid] || 0) + g * it.quantity; hasG[vid] = true; }
      }
    });
    var changes = [];
    items.forEach(function (it) {
      var p = it.properties || {};
      if (p['_lié'] != null) {                         // supplément éphémère par saveur (+unit)
        var parent = String(p['_lié']);
        var actual = it.quantity, exp;
        if (!present[parent]) exp = 0;                 // coffret/PM parent absent => orphelin
        else if (hasEph[parent]) exp = expected[parent] || 0;
        else return;                                   // parent présent mais _éph inconnu => ambigu => rien
        if (exp !== actual) changes.push({ id: it.key, quantity: exp });
      } else if (p['_liéG'] != null) {                 // B10-3 — supplément SOMMITALE (+0,30)
        var parentG = String(p['_liéG']);
        var actualG = it.quantity, expG;
        if (!present[parentG]) expG = 0;               // parent absent => orphelin, on supprime
        else if (hasG[parentG]) expG = expectedG[parentG] || 0; // = nb de boîtes à grande éphémère
        else expG = 0;                                 // parent présent mais plus de grande éphémère => supprimer
        if (expG !== actualG) changes.push({ id: it.key, quantity: expG });
      }
    });
    return changes;
  }

  function apply(changes, i) {
    if (i >= changes.length) {
      busy = false;
      // Demande à Horizon de re-render panier/drawer. Source marquée => notre écouteur l'ignore.
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'ladivine-cart-sync' } } }));
      return;
    }
    fetch(ldRacine() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(changes[i])
    }).then(function () { apply(changes, i + 1); })
      .catch(function () { busy = false; }); // fail-safe : on stoppe, pas de boucle
  }

  function reconcile() {
    if (busy) return;
    fetch(ldRacine() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (busy) return;
        var changes = computeChanges(cart);
        if (!changes.length) return;
        busy = true;
        apply(changes, 0);
      })
      .catch(function () {});
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 150); }

  // GC4 — garantit que le bloc « code promo » reste le DERNIER élément avant le CTA,
  // même si Pickeasy s'injecte après lui (asynchrone). Guard « déjà en place » = pas de boucle.
  function anchorPromos() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var parent = ctas.parentNode;
      if (!parent) return;
      var promo = parent.querySelector(':scope > .cart-actions--discount');
      if (!promo || ctas.previousElementSibling === promo) return;
      parent.insertBefore(promo, ctas);
    });
  }

  // MutationObserver sur le(s) conteneur(s) de la colonne : re-positionne la promo à chaque
  // injection (Pickeasy). Ré-établi après un re-render Horizon (le morph remplace le DOM).
  var promoObservers = [];
  function setupPromoObservers() {
    promoObservers.forEach(function (o) { o.disconnect(); });
    promoObservers = [];
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var parent = ctas.parentNode;
      if (!parent) return;
      var mo = new MutationObserver(function () { anchorPromos(); });
      mo.observe(parent, { childList: true });
      promoObservers.push(mo);
    });
    anchorPromos();
  }

  document.addEventListener('cart:update', function (e) {
    setupPromoObservers();
    if (busy) return;
    if (e && e.detail && e.detail.data && e.detail.data.source === 'ladivine-cart-sync') return; // notre propre event
    schedule();
  });

  function init() {
    schedule();
    setupPromoObservers();
    // Pickeasy s'injecte de façon asynchrone : quelques passes après le load (au cas où l'observer
    // n'a pas encore le bon parent, ou Pickeasy injecte hors du conteneur observé).
    [400, 1200, 2500].forEach(function (d) { setTimeout(setupPromoObservers, d); });
  }

  // Contrôle initial au chargement (couvre l'arrivée directe avec un orphelin déjà présent).
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
